import { render, staticRenderFns } from "./TabPanelPerfilAcessoFiscalizador.vue?vue&type=template&id=b6889a16&"
import script from "./TabPanelPerfilAcessoFiscalizador.vue?vue&type=script&lang=js&"
export * from "./TabPanelPerfilAcessoFiscalizador.vue?vue&type=script&lang=js&"
import style0 from "./TabPanelPerfilAcessoFiscalizador.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports